var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fluent:copy-16-filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5 5.10625V13.125C4.99988 13.9184 5.30154 14.6821 5.8438 15.2613C6.38606 15.8405 7.12831 16.1917 7.92 16.2437L8.125 16.25H13.6425C13.5133 16.6155 13.2739 16.932 12.9574 17.1559C12.6408 17.3797 12.2627 17.4999 11.875 17.5H7.5C6.50544 17.5 5.55161 17.1049 4.84835 16.4017C4.14509 15.6984 3.75 14.7446 3.75 13.75V6.875C3.7498 6.48709 3.86991 6.10867 4.09379 5.79189C4.31766 5.4751 4.63428 5.23555 5 5.10625ZM14.375 2.5C14.8723 2.5 15.3492 2.69754 15.7008 3.04917C16.0525 3.40081 16.25 3.87772 16.25 4.375V13.125C16.25 13.6223 16.0525 14.0992 15.7008 14.4508C15.3492 14.8025 14.8723 15 14.375 15H8.125C7.62772 15 7.15081 14.8025 6.79917 14.4508C6.44754 14.0992 6.25 13.6223 6.25 13.125V4.375C6.25 3.87772 6.44754 3.40081 6.79917 3.04917C7.15081 2.69754 7.62772 2.5 8.125 2.5H14.375Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.6be43d942e07b51032834c9860b866b0.svg";
export { ForwardRef as ReactComponent };